/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import Breadcrumb from '../../Layouts/Breadcrumb';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Avatar from '@material-ui/core/Avatar';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Tooltip from '@material-ui/core/Tooltip';
import Popover from '@material-ui/core/Popover';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import { createSwalLoaderNode } from '../../Layouts/swalLoader';

import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SearchIcon from '@material-ui/icons/Search';
import ImageIcon from '@material-ui/icons/Image';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import DescriptionIcon from '@material-ui/icons/Description';

import AuthApi from '../../Services/Authapi';
import swal from 'sweetalert';
import ls from 'local-storage';
import AuthCheckComponent from '../../Layouts/Token';
import PageLoader from '../../Layouts/PageLoader';
import DdMmYyyyDateField from '../../../utils/DdMmYyyyDateField';
import moment from 'moment';

import './TaskManagement.css';
import '../Leaves/Leave.css';
import '../Attendance/Attendance.css';
import './job.css';
import '../LeavesTicket/Ticket.css';

// Upload Icon matching user specification (Tray + Up Arrow)
const TrayUploadIcon = ({ size = 20, style = {} }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);

const EditProject = (props) => {
  const [formErrors, setFormErrors] = useState({});
  const [submitLoading, setSubmitLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  const [projectData, setProjectData] = useState({
    id: null,
    project_name: '',
    start_date: '',
    target_date: '',
    member_ids: [],
  });

  const [activeUsers, setActiveUsers] = useState([]);

  // User popover state
  const [userPopoverAnchor, setUserPopoverAnchor] = useState(null);
  const [userSearchQuery, setUserSearchQuery] = useState('');
  const avatarsScrollRef = useRef(null);

  // File attachments state (photos and all file types)
  const [projectFiles, setProjectFiles] = useState([]);
  const [existingFiles, setExistingFiles] = useState([]);
  const fileInputRef = useRef(null);

  // Milestone Text Area only state
  const [milestoneText, setMilestoneText] = useState('');
  const [initialProjectName, setInitialProjectName] = useState('');

  const isUserSuperAdmin = () => {
    try {
      const roles = ls.get('roles') || ls('roles');
      if (!roles) return false;
      const adminRoles = ['super admin', 'admin', 'administrator'];
      if (typeof roles === 'string') {
        const r = roles.trim().toLowerCase();
        return adminRoles.includes(r);
      }
      if (Array.isArray(roles)) {
        return roles.some((r) => {
          const name = (typeof r === 'string' ? r : (r && r.name) || '').trim().toLowerCase();
          return adminRoles.includes(name);
        });
      }
      return false;
    } catch (_) {
      return false;
    }
  };

  const extractIds = (raw) => {
    if (!raw) return [];
    if (Array.isArray(raw)) {
      return raw
        .map((item) => (typeof item === 'object' && item !== null ? item.id || item.user_id : item))
        .map(Number)
        .filter((id) => !isNaN(id));
    }
    if (typeof raw === 'string') {
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          return parsed
            .map((item) => (typeof item === 'object' && item !== null ? item.id || item.user_id : item))
            .map(Number)
            .filter((id) => !isNaN(id));
        }
      } catch (_) {
        return raw.split(',').map(Number).filter((id) => !isNaN(id));
      }
    }
    if (typeof raw === 'number') return [raw];
    return [];
  };

  useEffect(() => {
    if (!isUserSuperAdmin()) {
      swal('Access Denied', 'Only administrators can edit projects.', 'warning');
      props.history.replace('/tasks');
      return;
    }
    loadProjectData();
  }, [props.match.params.id]);

  const loadProjectData = async () => {
    setPageLoading(true);
    try {
      const projectId = props.match.params.id;
      const [singleRes, allUsersRes, allProjectsRes] = await Promise.all([
        AuthApi.singleProject(projectId),
        AuthApi.getData(),
        AuthApi.getProject(),
      ]);

      const users = (allUsersRes && allUsersRes.data) || allUsersRes || [];
      const loggedActive = Array.isArray(users) ? users.filter((u) => Number(u.user_logged) === 1) : [];
      setActiveUsers(loggedActive);

      let targetProject = null;
      if (singleRes && (singleRes.data || singleRes.id || singleRes.project_name)) {
        targetProject = singleRes.data || singleRes;
      }
      if (!targetProject && allProjectsRes) {
        const pList = (allProjectsRes && allProjectsRes.data) || allProjectsRes || [];
        if (Array.isArray(pList)) {
          targetProject = pList.find((p) => String(p.id) === String(projectId));
        }
      }

      if (!targetProject) {
        swal('Error', 'Project not found', 'error');
        props.history.replace('/manageproject');
        return;
      }

      const memberIds = extractIds(
        targetProject.member_ids || targetProject.members || targetProject.developer_id
      );

      setProjectData({
        id: targetProject.id,
        project_name: targetProject.project_name || '',
        start_date: targetProject.start_date || '',
        target_date: targetProject.target_date || '',
        member_ids: memberIds,
      });
      setInitialProjectName(targetProject.project_name || '');

      // Milestones text or description
      const desc = targetProject.description || '';
      if (desc) {
        setMilestoneText(desc);
      } else if (Array.isArray(targetProject.milestones) && targetProject.milestones.length > 0) {
        setMilestoneText(targetProject.milestones.map((m) => m.name || m).join('\n'));
      }

      // Existing resources/files if available
      if (Array.isArray(targetProject.resources)) {
        setExistingFiles(targetProject.resources);
      }
    } catch (err) {
      console.error('Error loading project for edit:', err);
      swal('Error', 'Failed to load project details', 'error');
    } finally {
      setPageLoading(false);
    }
  };

  // Horizontal scroll wheel for selected user avatars
  useEffect(() => {
    const el = avatarsScrollRef.current;
    if (!el) return;

    const handleWheel = (e) => {
      const delta = Math.abs(e.deltaY) >= Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
      if (delta !== 0) {
        e.preventDefault();
        e.stopPropagation();
        el.scrollBy({ left: Math.sign(delta) * 44, behavior: 'smooth' });
      }
    };

    el.addEventListener('wheel', handleWheel, { passive: false });
    return () => {
      el.removeEventListener('wheel', handleWheel);
    };
  }, [projectData.member_ids]);

  const getInitials = (name) => {
    if (!name) return 'U';
    return name
      .split(' ')
      .filter(Boolean)
      .map((part) => part[0].toUpperCase())
      .slice(0, 2)
      .join('');
  };

  // --- File Upload Handlers ---
  const handleFileSelect = (e) => {
    const selected = Array.from(e.target.files || []);
    if (selected.length > 0) {
      setProjectFiles((prev) => [...prev, ...selected]);
    }
    e.target.value = null;
  };

  const handleRemoveFile = (index) => {
    swal({
      title: 'Are you sure?',
      text: 'Are you sure you want to remove this file?',
      icon: 'warning',
      buttons: ['Cancel', 'Yes'],
      dangerMode: true,
    }).then((confirm) => {
      if (confirm) {
        setProjectFiles((prev) => prev.filter((_, i) => i !== index));
      }
    });
  };

  const handleRemoveExistingFile = (index) => {
    swal({
      title: 'Are you sure?',
      text: 'Are you sure you want to remove this file?',
      icon: 'warning',
      buttons: ['Cancel', 'Yes'],
      dangerMode: true,
    }).then((confirm) => {
      if (confirm) {
        setExistingFiles((prev) => prev.filter((_, i) => i !== index));
      }
    });
  };

  // --- Form Submit Handler ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = {};

    if (!projectData.project_name.trim()) {
      errors.project_name = 'Project name is required';
    }

    if (!projectData.member_ids || projectData.member_ids.length === 0) {
      errors.member_ids = 'Please select at least one user';
    }

    if (
      projectData.start_date &&
      projectData.target_date &&
      projectData.target_date < projectData.start_date
    ) {
      errors.target_date = 'End date cannot be before start date';
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    setSubmitLoading(true);
    swal({
      title: "Loading",
      text: "Please wait...",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      content: createSwalLoaderNode(),
    });

    try {
      const memberIds = (projectData.member_ids || []).map(Number);

      const payload = {
        project_name: projectData.project_name.trim(),
        summary: null,
        priority: 'No priority',
        start_date: projectData.start_date || null,
        target_date: projectData.target_date || null,
        description: milestoneText.trim() || null,
        lead_id: memberIds.length > 0 ? memberIds[0] : null,
        lead_ids: memberIds,
        member_ids: memberIds,
      };

      const newProjectName = projectData.project_name.trim();
      const res = await AuthApi.editProject(payload, projectData.id);
      if (res && (res.status === true || res.status === 200 || res.success)) {
        // Cascade project name change to any tasks assigned to the old project name
        if (initialProjectName && newProjectName && initialProjectName.trim().toLowerCase() !== newProjectName.toLowerCase()) {
          try {
            const tasksRes = await AuthApi.getTasks();
            const rawTasks = (tasksRes && tasksRes.data) || (Array.isArray(tasksRes) ? tasksRes : []);
            const matchingTasks = rawTasks.filter(
              (t) => String(t.project_name || '').trim().toLowerCase() === initialProjectName.trim().toLowerCase()
            );
            for (const t of matchingTasks) {
              try {
                const devUserId = t.developer_user_id || (t.member_ids && t.member_ids[0]) || '';
                const memberIds = Array.isArray(t.member_ids) ? t.member_ids : (t.developer_user_ids || (devUserId ? [Number(devUserId)] : []));
                let subTasksList = [];
                try {
                  const rawSub = t.sub_tasks || t.subTasks;
                  let parsed = typeof rawSub === 'string' ? JSON.parse(rawSub) : rawSub;
                  while (typeof parsed === 'string') parsed = JSON.parse(parsed);
                  if (Array.isArray(parsed)) subTasksList = parsed;
                } catch (_) {}

                const taskUpdatePayload = {
                  task: (t.task || '').trim(),
                  project_name: newProjectName,
                  description: t.description || '',
                  status: t.status || 'Pending',
                  priority: t.priority || 'Medium',
                  developer_user_id: devUserId,
                  developer_name: t.developer_name || '',
                  developer_user_ids: memberIds,
                  member_ids: memberIds,
                  task_date_time: t.task_date_time || moment().format('YYYY-MM-DD HH:mm:ss'),
                  task_deliver_date: t.task_deliver_date || null,
                  sub_tasks: subTasksList
                };
                await AuthApi.updateTask(t.id, taskUpdatePayload);
              } catch (upErr) {
                console.error(`Error updating task ${t.id} project_name:`, upErr);
              }
            }
          } catch (taskErr) {
            console.error('Error cascading project name update to tasks:', taskErr);
          }
        }

        // Upload any newly attached documents and photos
        if (projectData.id && projectFiles.length > 0) {
          try {
            await Promise.all(
              projectFiles.map((file) =>
                AuthApi.uploadProjectResource(projectData.id, file, file.name)
              )
            );
          } catch (uploadErr) {
            console.error('Error uploading project files:', uploadErr);
          }
        }

        swal.close();
        props.history.push('/manageproject');
        swal('Success', (res && res.message) || 'Project updated successfully!', 'success');
      } else {
        swal.close();
        swal('Error', (res && res.message) || 'Failed to update project.', 'error');
      }
    } catch (err) {
      console.error('Error updating project:', err);
      swal.close();
      swal('Error', 'An unexpected error occurred while updating project.', 'error');
    } finally {
      setSubmitLoading(false);
    }
  };

  if (pageLoading) {
    return (
      <div>
        <AuthCheckComponent authToken={props.authToken} />
        <Header {...props} authUser={props.authUser} setAutUser={props.setAutUser} component={<PageLoader />} />
        <Footer />
      </div>
    );
  }

  const isUsersSelected = (projectData.member_ids || []).length > 0;

  const pageContent = (
    <div style={{ marginBottom: '11%' }}>
      {/* Breadcrumb Card */}
      <div className="holiday-breadcrumb-card">
        <Breadcrumb
          {...props}
          primaryPageName="Tasks"
          primaryPageLink="/tasks"
          isSecondaryPage={true}
          secondaryPageName="Edit Project"
        />
      </div>

      {/* Form Card */}
      <div className="holiday-form-card">
        <Typography
          variant="h2"
          className="holiday-form-title"
          style={{
            color: '#036dda',
            fontSize: '24px',
            fontWeight: 'bold',
            marginBottom: '20px',
          }}
        >
          Edit Project
        </Typography>

        <form className="common-form-fields leave-ticket-form" onSubmit={handleSubmit} noValidate>
          <Grid container spacing={5}>
            {/* Project Name * */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                variant="outlined"
                id="project_name"
                name="project_name"
                label="Project name *"
                value={projectData.project_name}
                onChange={(e) => {
                  setProjectData({ ...projectData, project_name: e.target.value });
                  if (formErrors.project_name) {
                    setFormErrors((prev) => ({ ...prev, project_name: '' }));
                  }
                }}
                error={Boolean(formErrors.project_name)}
                className={formErrors.project_name ? "input-error" : ""}
              />
              {formErrors.project_name && (
                <span className="error">{formErrors.project_name}</span>
              )}
            </Grid>

            {/* Select User * */}
            <Grid item xs={12} sm={6}>
              <div style={{ position: 'relative' }}>
                <TextField
                  fullWidth
                  variant="outlined"
                  id="select_user"
                  name="select_user"
                  label="Select user *"
                  value={isUsersSelected ? " " : ""}
                  onClick={(e) => setUserPopoverAnchor(e.currentTarget)}
                  error={Boolean(formErrors.member_ids)}
                  className={formErrors.member_ids ? "input-error" : ""}
                  InputLabelProps={{
                    shrink: isUsersSelected ? true : undefined,
                  }}
                  InputProps={{
                    readOnly: true,
                    style: {
                      cursor: 'pointer',
                      padding: '0 14px',
                      height: '56px',
                      minHeight: '56px',
                      display: 'flex',
                      alignItems: 'center',
                    },
                    startAdornment: isUsersSelected ? (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          width: 'calc(100% - 28px)',
                          overflow: 'hidden',
                        }}
                      >
                        <span className="tm-selected-users-text">
                          {projectData.member_ids.length} user(s) selected
                        </span>

                        <div
                          ref={avatarsScrollRef}
                          className="tm-avatars-scroll"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            overflowX: 'auto',
                            overflowY: 'hidden',
                            maxWidth: '100%',
                            padding: '2px 12px 2px 4px',
                            flex: 1,
                            marginRight: 6,
                          }}
                        >
                          {projectData.member_ids.map((uid) => {
                            const u = activeUsers.find((user) => Number(user.id) === Number(uid));
                            const name = u
                              ? (u.firstName ? `${u.firstName} ${u.lastName || ''}`.trim() : u.name)
                              : `User #${uid}`;
                            return (
                              <Tooltip key={uid} title={name} arrow>
                                <Avatar
                                  src={u && u.photo ? u.photo : ''}
                                  style={{
                                    width: 32,
                                    height: 32,
                                    fontSize: 12,
                                    fontWeight: 700,
                                    flexShrink: 0,
                                    backgroundColor: '#036dda',
                                    color: '#ffffff',
                                    border: '2px solid #ffffff',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
                                  }}
                                >
                                  {getInitials(name)}
                                </Avatar>
                              </Tooltip>
                            );
                          })}
                        </div>
                      </div>
                    ) : null,
                    endAdornment: (
                      <InputAdornment position="end">
                        <ExpandMoreIcon style={{ cursor: 'pointer', color: '#036dda' }} />
                      </InputAdornment>
                    ),
                    inputProps: {
                      readOnly: true,
                      style: {
                        cursor: 'pointer',
                        display: isUsersSelected ? 'none' : 'block',
                      },
                    },
                  }}
                />

                <Popover
                  open={Boolean(userPopoverAnchor)}
                  anchorEl={userPopoverAnchor}
                  onClose={() => {
                    setUserPopoverAnchor(null);
                    setUserSearchQuery('');
                  }}
                  disableScrollLock
                  getContentAnchorEl={null}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                  PaperProps={{
                    className: 'attendance-user-popover-paper',
                    style: {
                      width: 300,
                      marginTop: 5,
                      borderRadius: 8,
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      backgroundColor: '#ffffff',
                    },
                  }}
                >
                  <Box p={1.5} className="attendance-user-popover-header">
                    <Typography
                      variant="subtitle2"
                      className="attendance-user-popover-title"
                      style={{
                        fontWeight: 700,
                        marginBottom: 8,
                        color: '#ffffff',
                      }}
                    >
                      Select User
                    </Typography>
                    <TextField
                      className="common-user-search-field"
                      fullWidth
                      size="small"
                      placeholder="Search users..."
                      variant="outlined"
                      value={userSearchQuery}
                      onChange={(e) => setUserSearchQuery(e.target.value)}
                      InputProps={{
                        style: {
                          backgroundColor: '#ffffff',
                          borderRadius: '4px',
                          height: '36px',
                        },
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon fontSize="small" style={{ color: '#036dda' }} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                  <Divider />
                  <div style={{ maxHeight: 300, overflowY: 'auto' }}>
                    <MenuItem
                      className="attendance-user-option"
                      selected={
                        activeUsers.length > 0 &&
                        activeUsers.every((u) =>
                          (projectData.member_ids || []).map(Number).includes(Number(u.id))
                        )
                      }
                      onClick={() => {
                        const allIds = activeUsers.map((u) => Number(u.id));
                        const isAllSelected =
                          allIds.length > 0 &&
                          allIds.every((id) =>
                            (projectData.member_ids || []).map(Number).includes(id)
                          );
                        const updated = isAllSelected ? [] : allIds;
                        setProjectData({
                          ...projectData,
                          member_ids: updated,
                        });
                        if (formErrors.member_ids && updated.length > 0) {
                          setFormErrors((prev) => ({ ...prev, member_ids: '' }));
                        }
                      }}
                      style={{ padding: '8px 16px' }}
                    >
                      <ListItemText primary="All Users" />
                      {activeUsers.length > 0 &&
                        activeUsers.every((u) =>
                          (projectData.member_ids || []).map(Number).includes(Number(u.id))
                        ) && <CheckIcon style={{ color: '#ffffff', fontSize: '1.2rem' }} />}
                    </MenuItem>
                    {activeUsers
                      .filter((u) => {
                        const q = (userSearchQuery || '').toLowerCase();
                        const name = (
                          u.firstName ? `${u.firstName} ${u.lastName || ''}` : u.name || ''
                        ).toLowerCase();
                        return name.includes(q);
                      })
                      .map((user) => {
                        const displayName = user.firstName
                          ? `${user.firstName} ${user.lastName || ''}`.trim()
                          : user.name;
                        const isChecked = (projectData.member_ids || []).map(Number).includes(Number(user.id));
                        return (
                          <MenuItem
                            key={user.id}
                            className="attendance-user-option"
                            selected={isChecked}
                            onClick={() => {
                              const current = (projectData.member_ids || []).map(Number);
                              const updated = isChecked
                                ? current.filter((id) => id !== Number(user.id))
                                : [...current, Number(user.id)];
                              setProjectData({
                                ...projectData,
                                member_ids: updated,
                              });
                              if (formErrors.member_ids && updated.length > 0) {
                                setFormErrors((prev) => ({ ...prev, member_ids: '' }));
                              }
                            }}
                            style={{ padding: '8px 16px' }}
                          >
                            <Box display="flex" alignItems="center" width="100%">
                              <Avatar
                                src={user.photo || ''}
                                style={{ width: 32, height: 32, marginRight: 12, fontSize: '0.9rem' }}
                              >
                                {getInitials(displayName)}
                              </Avatar>
                              <ListItemText primary={displayName} />
                              {isChecked && (
                                <CheckIcon style={{ color: '#ffffff', fontSize: '1.2rem' }} />
                              )}
                            </Box>
                          </MenuItem>
                        );
                      })}
                    {activeUsers.length === 0 && (
                      <div style={{ padding: 16, textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>
                        No active users found
                      </div>
                    )}
                  </div>
                </Popover>
              </div>
              {formErrors.member_ids && (
                <span className="error">{formErrors.member_ids}</span>
              )}
            </Grid>

            {/* Start Date */}
            <Grid item xs={12} sm={6}>
              <DdMmYyyyDateField
                id="page_project_start_date"
                name="page_project_start_date"
                label="Start date"
                size="medium"
                value={projectData.start_date}
                onChange={(e) => {
                  setProjectData({ ...projectData, start_date: e.target.value });
                  if (formErrors.target_date) {
                    setFormErrors((prev) => ({ ...prev, target_date: '' }));
                  }
                }}
                max={projectData.target_date || undefined}
                className={formErrors.start_date ? "input-error" : ""}
              />
              {formErrors.start_date && (
                <span className="error">{formErrors.start_date}</span>
              )}
            </Grid>

            {/* End Date */}
            <Grid item xs={12} sm={6}>
              <DdMmYyyyDateField
                id="page_project_target_date"
                name="page_project_target_date"
                label="End date"
                size="medium"
                value={projectData.target_date}
                onChange={(e) => {
                  setProjectData({ ...projectData, target_date: e.target.value });
                  if (formErrors.target_date) {
                    setFormErrors((prev) => ({ ...prev, target_date: '' }));
                  }
                }}
                error={Boolean(formErrors.target_date)}
                className={formErrors.target_date ? "input-error" : ""}
                min={projectData.start_date || undefined}
              />
              {formErrors.target_date && (
                <span className="error">{formErrors.target_date}</span>
              )}
            </Grid>

            {/* Document Upload (Photo and all type file upload) */}
            <Grid item xs={12}>
              <input
                type="file"
                ref={fileInputRef}
                id="project-files-input"
                multiple
                accept="image/*,.jpg,.jpeg,.png,.webp,.gif,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv"
                style={{ display: 'none' }}
                onChange={handleFileSelect}
              />
              <TextField
                fullWidth
                variant="outlined"
                label="Document upload"
                value={
                  ((projectFiles ? projectFiles.length : 0) + (existingFiles ? existingFiles.length : 0)) > 0
                    ? `${(projectFiles ? projectFiles.length : 0) + (existingFiles ? existingFiles.length : 0)} file${((projectFiles ? projectFiles.length : 0) + (existingFiles ? existingFiles.length : 0)) > 1 ? 's' : ''} attached`
                    : ''
                }
                onClick={() => fileInputRef.current && fileInputRef.current.click()}
                inputProps={{
                  readOnly: true,
                  style: {
                    cursor: 'pointer',
                    textOverflow: 'ellipsis',
                  },
                }}
                InputProps={{
                  style: {
                    cursor: 'pointer',
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <Tooltip title="Upload documents or photos (All types supported)" arrow placement="top">
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            fileInputRef.current && fileInputRef.current.click();
                          }}
                          className="tm-desc-upload-btn"
                          aria-label="Upload file"
                        >
                          <TrayUploadIcon size={21} style={{ color: '#036dda' }} />
                        </IconButton>
                      </Tooltip>
                    </InputAdornment>
                  ),
                }}
              />

              {/* Existing Uploaded Files + Selected Files List */}
              {(existingFiles.length > 0 || projectFiles.length > 0) && (
                <div
                  style={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6,
                    maxHeight: 180,
                    overflowY: 'auto',
                  }}
                >
                  {existingFiles.map((res, i) => (
                    <div key={`existing-${i}`} className="tm-selected-file-item">
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 6,
                          overflow: 'hidden',
                          minWidth: 0,
                        }}
                      >
                        <DescriptionIcon style={{ color: '#036dda', fontSize: 18, flexShrink: 0 }} />
                        <span
                          style={{
                            fontWeight: 500,
                            color: 'var(--tm-text)',
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            fontSize: 12,
                          }}
                          title={res.title || res.name || `File #${i + 1}`}
                        >
                          {res.title || res.name || `File #${i + 1}`}
                        </span>
                        <span style={{ fontSize: 10, color: '#16a34a', fontWeight: 600, flexShrink: 0 }}>
                          (Existing)
                        </span>
                      </div>
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRemoveExistingFile(i);
                        }}
                        style={{ color: '#94a3b8', padding: 2, marginLeft: 4, flexShrink: 0 }}
                        title="Remove file"
                      >
                        <CloseIcon style={{ fontSize: 16 }} />
                      </IconButton>
                    </div>
                  ))}

                  {projectFiles.map((file, idx) => {
                    const isImg = file.type ? file.type.startsWith('image/') : false;
                    const isPdf =
                      file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
                    const isWord =
                      file.name.toLowerCase().endsWith('.doc') ||
                      file.name.toLowerCase().endsWith('.docx');
                    return (
                      <div key={`new-${idx}`} className="tm-selected-file-item">
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 6,
                            overflow: 'hidden',
                            minWidth: 0,
                          }}
                        >
                          {isImg ? (
                            <ImageIcon style={{ color: '#0284c7', fontSize: 18, flexShrink: 0 }} />
                          ) : isPdf ? (
                            <PictureAsPdfIcon style={{ color: '#ef4444', fontSize: 18, flexShrink: 0 }} />
                          ) : isWord ? (
                            <DescriptionIcon style={{ color: '#2563eb', fontSize: 18, flexShrink: 0 }} />
                          ) : (
                            <InsertDriveFileIcon style={{ color: '#64748b', fontSize: 18, flexShrink: 0 }} />
                          )}
                          <span
                            style={{
                              fontWeight: 500,
                              color: 'var(--tm-text)',
                              textOverflow: 'ellipsis',
                              overflow: 'hidden',
                              whiteSpace: 'nowrap',
                              fontSize: 12,
                            }}
                            title={file.name}
                          >
                            {file.name}
                          </span>
                          <span style={{ fontSize: 10, color: '#64748b', flexShrink: 0 }}>
                            ({(file.size / 1024).toFixed(0)}KB)
                          </span>
                        </div>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleRemoveFile(idx);
                          }}
                          style={{ color: '#94a3b8', padding: 2, marginLeft: 4, flexShrink: 0 }}
                          title="Remove file"
                        >
                          <CloseIcon style={{ fontSize: 16 }} />
                        </IconButton>
                      </div>
                    );
                  })}
                </div>
              )}
            </Grid>

            {/* Milestone (Text Area, auto-expanding without scrollbar) */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rowsMin={4}
                variant="outlined"
                id="milestone"
                name="milestone"
                label="Milestone"
                placeholder="Enter milestone..."
                value={milestoneText}
                onChange={(e) => setMilestoneText(e.target.value)}
                inputProps={{
                  style: {
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                    overflowY: 'hidden',
                  },
                }}
              />
            </Grid>
          </Grid>

          {/* Action Buttons (Save & Cancel matching AddTickets.js) */}
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={4} style={{ display: 'flex' }}>
              <Button
                type="submit"
                className="btn-success"
                style={{ marginTop: '10px', textTransform: 'none' }}
                variant="contained"
                color="primary"
                disabled={submitLoading}
              >
                {submitLoading ? (
                  <>
                    <CircularProgress size={18} style={{ marginRight: 8, color: 'inherit' }} />
                    Saving...
                  </>
                ) : (
                  'Save'
                )}
              </Button>
              <Button
                type="button"
                className="btn-cancel"
                style={{ marginTop: '10px', textTransform: 'none' }}
                onClick={(e) => {
                  e.preventDefault();
                  props.history.push('/manageproject');
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item xs={12} sm={6} md={4}></Grid>
            <Grid item xs={12} sm={6} md={4}></Grid>
          </Grid>
        </form>
      </div>
    </div>
  );

  return (
    <div>
      <AuthCheckComponent authToken={props.authToken} />
      <Header {...props} authUser={props.authUser} setAutUser={props.setAutUser} component={pageContent} />
      <Footer />
    </div>
  );
};

export default EditProject;
